/**
 * IndexedDB analytics functions
 */

export function initialise () {
	console.log('[Analytics] IndexedDB initialised');
}

/**
 * Tracking route function
 */
// export function trackRoute (route: any, sessionID: string) {
// 	/**
// 	 * Indexed DB Actions
// 	 * TODO: Error to investigate
// 	 */

// 	/*
// 	if (!('indexedDB' in window)) {
// 		console.warn('[ERR]: Disabling tracking data, No IndexedDB support found');
// 	} else {
// 		try {
// 			// DB Create
// 			const dbPromise = indexedDB.open('pfizer-covid-analytics-db', 1);

// 			// Collection creation - first time
// 			dbPromise.onupgradeneeded = (event: any) => {
// 				const db = event.target.result;
// 				if (!db.objectStoreNames.contains('analytics')) {
// 					db.createObjectStore('analytics', { autoIncrement: true });
// 				}
// 			};

// 			// Adding data to the IndexedDB
// 			dbPromise.onsuccess = (event: any) => {
// 				const db = event.target.result;
// 				const transaction = db.transaction(['analytics'], 'readwrite');

// 				const objectStore = transaction.objectStore('analytics');
// 				const request = objectStore.add(Object.assign({}, route, { sessionID }));
// 				request.onsuccess = () => {
// 					console.log(`[IndexedDB]: ${Date.now()}:: Record added to IndexedDB`);
// 				};
// 			};
// 		} catch (err) {
// 			console.warn(err);
// 		}
// 	}
// 	*/
// }